import { motion } from 'framer-motion'
import styled, { css } from 'styled-components/macro'

import { IconRfe } from 'components/icons/rfe'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'

export const LogoContainer = styled.div`
  font-size: 8rem;
  margin: 3rem auto;
  text-align: center;
  line-height: 0.6;

  ${mq.medium} {
    margin: 5rem auto;
    font-size: 9rem;
  }

  ${mq.large} {
    font-size: 10.7rem;
  }
`

export const Logo = styled(IconRfe)`
  display: inline-block;
`

export const Title = styled.h1`
  font-size: 3rem;
  line-height: 1.48;
  font-weight: 800;
  margin: 3rem auto 0;
  text-align: center;
  max-width: 78rem;
  text-transform: uppercase;

  ${mq.medium} {
    font-size: 5rem;
    margin-top: 5rem;
  }

  ${mq.large} {
    font-size: 7.2rem;
  }
`

export const Intro = styled.div`
  margin: 0 auto 3rem;
  font-size: 1.6rem;
  text-align: justify;
  text-align-last: center;
  hyphens: auto;
  max-width: 78rem;

  a {
    color: ${theme.colors.accent.rfe};
  }

  ${mq.medium} {
    font-size: 1.8rem;
    margin-bottom: 5rem;
  }

  ${mq.large} {
    font-size: 2.1rem;
  }
`

export const ListContainer = styled.div``

export const Backdrop = styled.div.attrs({ role: 'button', tabIndex: 0 })<{
  $isVisible: boolean
}>`
  display: block;
  position: fixed;
  inset: -20px;
  opacity: 0;
  pointer-events: none;
  transition: 0.3s all;
  background-color: rgba(255 255 255 / 70%);
  z-index: 5;

  ${props =>
    props.$isVisible &&
    css`
      opacity: 1;
      pointer-events: auto;
      backdrop-filter: blur(10px);
      cursor: pointer;
    `}
`

export const List = styled(motion.ul)`
  position: relative;
  list-style: none;
  margin: 3rem 0;
  padding: 0;

  ${mq.smallOnly} {
    display: flex;
    flex-wrap: wrap;
    gap: 0.8rem;

    /* Fixes with of the last element on mobile when there are 2n+1 items */
    &:has(li:last-child:nth-child(2n + 1))::after {
      content: '';
      display: block;
      width: 0;
      flex-grow: 1;
      flex-basis: calc(50% - 0.4rem);
    }
  }

  ${mq.medium} {
    display: grid;
    justify-content: center;
    grid-template-columns: repeat(auto-fill, minmax(26rem, 1fr));
    gap: 2rem;
  }

  li {
    display: flex;
    flex-direction: column;
    width: 100%;
    transform-origin: 50% 50%;
    perspective: 130vw;

    ${mq.smallOnly} {
      width: 0;
      flex-grow: 1;
      flex-basis: calc(50% - 0.4rem);
    }

    ${mq.medium} {
      perspective: 80vw;
    }
  }
`

export const NoResults = styled.p`
  text-align: center;
  padding-block: 3em;
`

export const FiltersWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 3rem;
  margin: 1.6rem 0 5rem;

  ${mq.smallOnly} {
    flex-direction: column;
    align-items: center;
    gap: 2rem;
  }
`
